import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { getMark, setMarks, getPluginType, useEventPlateId, usePlateEditorRef, usePlateEditorState, MARK_FONT_FAMILY, select, } from '@udecode/plate';
const availableFonts = [
    'Default',
    '"Times New Roman", Times, serif',
    'Arial, Helvetica, sans-serif',
    'Verdana, sans-serif',
    'Tahoma, sans-serif',
    '"Trebuchet MS", sans-serif',
    'Georgia, serif',
    'Garamond, serif',
    '"Courier New", monospace',
    '"Brush Script MT", cursive',
];
const getFontLabel = (family) => (family.split(',')[0].replace(/"/g, '')); // replaceAll('"', ''));
const FontFamilyToolbarButtons = ({ id, pluginKey = MARK_FONT_FAMILY, }) => {
    // const [appliedMarks, setAppliedMarks] = useState<any>();
    const eventEditorId = useEventPlateId(id);
    // console.log('eventEditorId', eventEditorId);
    const editor = usePlateEditorState(eventEditorId);
    // console.log('editor is', editor);
    const editorRef = usePlateEditorRef(eventEditorId);
    const type = getPluginType(editorRef, pluginKey);
    const fontFamily = editorRef && getMark(editorRef, type);
    const [, setSelectedFontFamily] = useState();
    useEffect(() => {
        if (editor?.selection) {
            setSelectedFontFamily(fontFamily);
        }
    }, [fontFamily, editor?.selection]);
    const update = (ev, newFontFamily) => {
        ev.preventDefault();
        if (editorRef && editor && editor.selection) {
            select(editorRef, editor.selection);
            setMarks(editor, { [type]: newFontFamily });
        }
    };
    return (_jsx(Autocomplete, { id: "combo-box-font-family", options: availableFonts, sx: { width: 200 }, getOptionLabel: getFontLabel, 
        // eslint-disable-next-line react/jsx-props-no-spreading
        renderInput: (params) => _jsx(TextField, { ...params, size: "small", label: "Font" }), renderOption: (props, option) => {
            const fontLabel = option ? getFontLabel(option) : 'Default';
            return (
            // eslint-disable-next-line react/jsx-props-no-spreading
            _jsx(Box, { sx: { fontFamily: fontLabel }, ...props, children: fontLabel }));
        }, value: fontFamily || 'Default', onChange: (event, newValue) => {
            event.preventDefault();
            event.stopPropagation();
            update(event, newValue === 'Default' ? undefined : newValue);
        } }));
};
FontFamilyToolbarButtons.defaultProps = {
    id: undefined,
    pluginKey: MARK_FONT_FAMILY,
};
export default FontFamilyToolbarButtons;
//# sourceMappingURL=FontFamilyToolbarButtons.js.map